import {
  DatabaseService,
  MercuryBalanceSnapshot,
  MercuryBalanceSnapshotData,
  MercuryBalanceSnapshotRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getMercuryBalanceSnapshotRepository(
  databaseService: DatabaseService,
): MercuryBalanceSnapshotRepository {
  return getGenericRepository<
    MercuryBalanceSnapshot,
    MercuryBalanceSnapshotData
  >(() => DatabaseCollection.MERCURY_BALANCE_SNAPSHOTS, databaseService);
}
